import { CLIENT_LOGOS } from "../data/content";

export default function LogoMarquee() {
  const items = [...CLIENT_LOGOS, ...CLIENT_LOGOS, ...CLIENT_LOGOS];
  return (
    <section data-testid="logo-marquee" className="relative w-full overflow-hidden bg-[#050505] py-12 md:py-16">
      <p className="pad-x mb-8 text-center text-[0.7rem] uppercase tracking-[0.3em] text-neutral-500">
        Trusted by artists, studios &amp; brands worldwide
      </p>
      <div className="relative overflow-hidden">
        <div className="marquee-track flex w-max animate-marquee items-center gap-16 whitespace-nowrap">
          {items.map((logo, i) => (
            <span
              key={i}
              className="font-playfair text-2xl text-white/60 grayscale transition-all duration-300 hover:text-white md:text-4xl"
            >
              {logo}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
